import { JSX } from 'react';
import { useIntl } from 'react-intl';

import { useStyles } from './media-section.styles';
import { ContentWrapper } from '../../../common/content-wrapper';
import { SectionTitle } from '../../../common/section-title';
import { Locales, SectionLabels } from '../../../../constants/common-constants';
import { mediaItems, mediaItemsUa } from './media.items';
import { Card } from '../card';
import { useLocale } from '../../../../context';

export const MediaSection = (): JSX.Element => {
  const classes = useStyles();
  const id = SectionLabels.media;
  const { locale } = useLocale();
  const mediaLink = '/media/';
  const items = locale === Locales.en ? mediaItems : mediaItemsUa;
  const intl = useIntl();

  return (
    <section
      className={classes.root}
      data-testid="media-section"
      aria-labelledby={id}
    >
      <ContentWrapper externalStyles={classes.content}>
        <SectionTitle
          id={id}
          isLight
          title="media.title"
          content="media.content"
          isVertical
          isFullWidth
        />
        <ul className={classes.list}>
          {items.map((item, index) => (
            <li className={classes.listItem} key={index}>
              <a
                href={`${mediaLink}${item.link}`}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
                aria-label={intl.formatMessage({ id: item.ariaLabel })}
              >
                <Card
                  title={item.title}
                  content={item.content}
                  isLink
                  isTopBorder
                />
              </a>
            </li>
          ))}
        </ul>
      </ContentWrapper>
    </section>
  );
};
